/**
 * A module representing notifications.
 * @module notification
 * @exports Notification
 * @see Notification
 * @requires module:helpers
 * @requires module:utils
 * @requires module:training
 * @requires module:dialog-manager
 * @example
 * var Notification = require('notification');
 */

define('notification',['helpers', 'utils', 'training', 'dialog-manager'], function(helpers, utils, Training, Dialog) {
    'use strict';

    var notifications,
        dialog,
        training;

    /**
     * @constructor
     * @alias Notifications
     * @param {Object} options
     * @param {Array} [options.answers] - User answers
     */
    function Notifications(options) {
        options = options || {}

        this.modal = options.modal || false;
        this.delay = (utils.isNumber(options.delay)) ? options.delay : 0;
        this.close = options.close || false;

        this.dataContext = options.dataContext || {};

        this.authenticationURL = options.authenticationURL || '/api/Authentication/IsAuthenticated';
        this.interval = options.interval || 60000;

        this.lang = {};

        this.modal = (this.dataContext.connection) ? !!this.dataContext.connection.modal : false;
        this.delay = (this.dataContext.connection && utils.isNumber(this.dataContext.connection.delay)) ? this.dataContext.connection.delay : 0;

        this.request = new Request(this.authenticationURL, {
            method: 'GET',
            headers: new Headers({'Authorization-Token': this.dataContext.tokenID})
        });

        this.online = this.online.bind(this);
        this.offline = this.offline.bind(this);
        this.openMessage = this.openMessage.bind(this);
        this.authentication = this.authentication.bind(this);

        if (this.modal) {
            this.init();
        }
    }

    Notifications.prototype.setLang = function(lang) {
        this.lang = lang;
    };

    Notifications.prototype.openMessage = function(options) {
        options = options || {};

        var notification = dialog.open({
            clone: true,
            container: document.getElementById('notifications'),
            content: options.content || '',
            showClose: this.close,
            overlay: false,
            mainClass: 'modal modal-notification'
        });

        if (this.delay) {
            setTimeout(function() {
               notification.close();
            }, this.delay);
        }
    };

    Notifications.prototype.offline = function() {
        if (!this.modal) {
            return;
        }

        this.openMessage({
            content: this.lang.connectionOffline || ''
        });
    };

    Notifications.prototype.online = function() {
        this.dataContext.logProgress('sync');

        if (!this.modal) {
            return;
        }

        this.openMessage({
            content: this.lang.connectionOnline || ''
        });
    };

    Notifications.prototype.authentication = function() {
        var _this = this;

        fetch(this.request).then(function(response) {
            if (response.status === 401 || response.ok === false) {
                _this.openMessage({
                    content: _this.lang.sessionTimeout
                });
            } else {
                setTimeout(_this.authentication.bind(this), _this.interval);
            }
        });
    };

    Notifications.prototype.init = function() {

        window.addEventListener('online', this.online, false);

        window.addEventListener('offline', this.offline, false);

        if (training.scormPackage) {

            require(['scormPackage'], function(ScormPackage) {
                var scormPackage = new ScormPackage();

                window.onpagehide = window.onbeforeunload = window.onunload = function(e) {
                    scormPackage.quit();

                    e.preventDefault();

                    return e.returnValue;
                };
            });

        } else if (!training.offlinePackage) {

            setTimeout(this.authentication, this.interval);
        }
    };

    return function(options) {

        if (!notifications) {
            dialog = new Dialog();
            training = new Training();

            notifications = new Notifications(options);
        }

        return notifications;
    };

});

